var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"robotTalk"},[_c('p',[_vm._v(" "+_vm._s(_vm.talkInfo.text.replace("##",_vm.nameforuser)))])])}
var staticRenderFns = []

export { render, staticRenderFns }